import { useMemo } from 'react';

export function usePreviewMode(): boolean {
    return useMemo(
        () => new URLSearchParams(window.location.search).get('preview') === 'true',
        []
    );
}
